import styled from 'styled-components'
import { GREEN, GREY, GREY_DARK, WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const TabContainer = styled.div`
background: ${WHITE};
border: 1px solid ${GREY};
box-sizing: border-box;
border-radius: 0px 8px 8px 8px;
padding: 30px;
margin-top: -1px;
`

export const ContainerDefault = styled(TabContainer)`
  border-radius: 8px 8px 8px 8px;
`

export const TabHeader = styled.div`
  margin-top: 80px;
  margin-bottom: 36px;
  h2 {
    color: ${GREEN};
    margin-bottom: 22px;.
    font-size: 48px;
  }

  p {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 3px;
    color: ${GREY_DARK};
  }

  .info {
    color: ${GREEN};
    font-size: 12px;
    line-height: 26px;
  }
`

export const Container = styled.div`
  width: 100%;
  // max-width: 1049px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: 1fr;

  @media (max-width: ${MD}) {
    display: block;
  }

  .content {
    flex: 0;
    padding: 0px 40px;
    width: 100%;
    max-width: 780px;
    margin-bottom: 100px;

    @media (max-width: ${MD}) {
      padding: 0px 32px;
    }
  }

  .navigation {
    background-color: ${WHITE};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`
